// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3JGuc","footer":"ModalUpdate_footer__27u6S"};